export default __webpack_public_path__ + "static/media/README.f7649d28.md";